module.exports = __webpack_public_path__ + "img/dsc-5280.dc22b7fc.jpg";